import React from 'react';
import './footer.css'
import Footeric from '../common/footericon';
import fic1 from '../../asserts/ic1.png'
import fic2 from '../../asserts/ic2.png'
import fic3 from '../../asserts/ic3.png'
import fic4 from '../../asserts/ic4.png'
import logo from '../../asserts/logo.png'

const Footer = (props) => {
    return ( <>
    <footer>
        <section className='footer-div'>
    <img className='l1' src={logo} alt="" />
          <p className='footertext'>
Trusted real estate expertise, delivered with integrity.<br /><br />

At Golden Health, we provide professional property representation and <br />strategic real estate
solutions tailored to your needs.<br /><br />

Follow us on social media for property insights, updates, and company news.
</p>
            <div className='footer-div2'>
            <Footeric fic={fic1} />
            <Footeric fic={fic2} />
            <Footeric fic={fic3} />
            <Footeric fic={fic4} />
            </div>      <div className='bottom-footer'>© 2026 Golden Hills  — All rights reserved.</div>

        </section>

              <section className='footer-div'>
            <p className='footertitle'>Quick Links</p>
     <Footeric fbtn='Home' />
     <Footeric fbtn='Menu' />
     <Footeric fbtn='Contact' />
     <Footeric fbtn='About Us' />

        
         
        </section>
                      <section className='footer-div'>
            <p className='footertitle'>Resources</p>
     <Footeric fbtn='Careers' />

     <Footeric fbtn='Sitemap' />
     <Footeric fbtn='FAQ' />
     <Footeric fbtn='Privacy ' />

        
         
        </section>
    </footer>
    </> );
}
 
export default Footer;